<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-flex ts-space-x-3"
  >
    <p class="ts-mb-0">{{$t('wholesale.fxRate')}} : <span class="ts-font-extrabold ts-text-red-600">{{ model.fx_rate }}</span></p>
    <!-- <p class="ts-mb-0">{{$t('wholesale.vatRate')}}: <span class="ts-font-extrabold ts-text-red-600">{{ model.vat_rate }}</span></p> -->
  </div>
</template>

<script>
export default {
  name: 'exchangeRate',
	props: ['value'],
  data() {
    return {
			model: {}
    }
  },
	created() {
    this.model = this.value
  },
}
</script>